import getConfig from 'next/config'

const runtimeConfig = getConfig().publicRuntimeConfig || {}
const lessVars = runtimeConfig.lessVars

export default lessVars